export interface AppEndpoints {
  apiBaseUrl: string;
  authApiBaseUrl: string;
  authAppBaseUrl: string;
  embeddedAgentFrontendUrl: string;
}

export const resolveAppEndpoints = (): AppEndpoints => {
  const origin = window.location.origin;
  const isLocal = origin.startsWith('http://localhost:');

  if (isLocal) {
    return {
      apiBaseUrl: 'http://localhost:3201',
      authApiBaseUrl: 'http://localhost:3001',
      authAppBaseUrl: 'http://localhost:4201',
      embeddedAgentFrontendUrl: 'http://localhost:4221',
    };
  }

  return {
    apiBaseUrl: 'https://acl-api.adaptivai.app',
    authApiBaseUrl: 'https://auth-central-api.adaptivai.app',
    authAppBaseUrl: 'https://auth-central.adaptivai.app',
    embeddedAgentFrontendUrl: 'https://agent.adaptivai.app',
  };
};
